import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight, FileBarChart } from "lucide-react";

export function RecentReportCard({ report, onOpen }) {
  return (
    <section className="mt-10 mb-6" data-testid="dashboard-recent-report">
      <div className="flex items-baseline justify-between gap-3">
        <h3 className="text-lg font-semibold text-slate-900">Your credit report</h3>
        <Link to="/app/upload" className="inline-flex items-center min-h-[44px] text-sm font-medium text-purple-700 hover:underline" data-testid="dashboard-view-all-reports">
          View All Reports<ChevronRight size={14} />
        </Link>
      </div>
      {!report ? (
        <p className="mt-2 text-sm text-slate-500" data-testid="dashboard-recent-report-empty">No report uploaded yet.</p>
      ) : (
        <div className="mt-3 flex flex-col sm:flex-row sm:items-center gap-4 rounded-2xl border border-slate-200 bg-white p-4">
          <FileBarChart size={28} className="text-purple-600 shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="text-sm font-semibold text-slate-900 truncate" data-testid="dashboard-recent-report-name">{report.original_filename || "Credit report"}</div>
            <div className="text-xs text-slate-500 mt-0.5">
              Uploaded {new Date(report.created_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })} · Stage: <span className="text-slate-700" data-testid="dashboard-recent-report-stage">{report.stage}</span>
            </div>
          </div>
          <Button variant="outline" onClick={() => onOpen(report.id)} className="min-h-[44px] rounded-xl border-slate-300 w-full sm:w-auto" data-testid="dashboard-open-report">
            Open Report
          </Button>
        </div>
      )}
    </section>
  );
}
